import React from 'react';
import {useTheme} from "@mui/material/styles";

const LoadingSpinner = () => {
    const theme = useTheme();

    return (
        <div style={{backgroundColor: theme.typography.mainContent?.backgroundColor, ...styles.container}}>
            <div style={styles.spinner}></div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
    },
    spinner: {
        width: '100px',
        height: '100px',
        border: '10px solid #ccc',
        borderTop: '10px solid #007bff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
    },
};

export default LoadingSpinner;